var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.837891C16.5304 0.837891 17.0391 1.0486 17.4142 1.42368C17.7893 1.79875 18 2.30746 18 2.83789V16.8379C18 17.3683 17.7893 17.877 17.4142 18.2521C17.0391 18.6272 16.5304 18.8379 16 18.8379H2C1.46957 18.8379 0.960859 18.6272 0.585786 18.2521C0.210714 17.877 0 17.3683 0 16.8379V2.83789C0 2.30746 0.210714 1.79875 0.585786 1.42368C0.960859 1.0486 1.46957 0.837891 2 0.837891H16ZM15.5 16.3379V11.0379C15.5 10.1733 15.1565 9.34409 14.5452 8.73272C13.9338 8.12135 13.1046 7.77789 12.24 7.77789C11.39 7.77789 10.4 8.29789 9.92 9.07789V7.96789H7.13V16.3379H9.92V11.4079C9.92 10.6379 10.54 10.0079 11.31 10.0079C11.6813 10.0079 12.0374 10.1554 12.2999 10.4179C12.5625 10.6805 12.71 11.0366 12.71 11.4079V16.3379H15.5ZM3.88 6.39789C4.32556 6.39789 4.75288 6.22089 5.06794 5.90583C5.383 5.59077 5.56 5.16345 5.56 4.71789C5.56 3.78789 4.81 3.02789 3.88 3.02789C3.43178 3.02789 3.00193 3.20594 2.68499 3.52288C2.36805 3.83982 2.19 4.26967 2.19 4.71789C2.19 5.64789 2.95 6.39789 3.88 6.39789ZM5.27 16.3379V7.96789H2.5V16.3379H5.27Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5a918bb5ac333ca4d3fd0d3fb81e457f.svg";
export { ForwardRef as ReactComponent };